import type {
  PageConfigRequest,
  PageConfigResponse,
} from '@/types/api/page-config'

import { TagTypes } from '@/types/api/tag-types'

import { baseApiSlice } from './base-api-slice'

export const pageConfigSlice = baseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPageConfig: builder.query<PageConfigResponse, string>({
      query: (id) => ({
        url: `bff/page-config/${id}/`,
        method: 'GET',
      }),
      // biome-ignore lint/correctness/noUnusedFunctionParameters: Bulk suppression as part of biome migration
      providesTags: (result, error, id) => [{ type: TagTypes.PageConfig, id }],
    }),
    updatePageConfig: builder.mutation<void, PageConfigRequest>({
      query: ({ id, version, config }) => ({
        url: `bff/page-config/${id}/`,
        method: 'PUT',
        body: { version, config },
      }),
      // biome-ignore lint/correctness/noUnusedFunctionParameters: Bulk suppression as part of biome migration
      invalidatesTags: (result, error, { id }) => [
        { type: TagTypes.PageConfig, id },
      ],
    }),
  }),
})

export const {
  endpoints: { getPageConfig, updatePageConfig },
  useGetPageConfigQuery,
  useUpdatePageConfigMutation,
} = pageConfigSlice
